export const STATUS_LABELS = {
    solicitud_recibida: "Solicitud Recibida",
    pendiente_cotizacion: "Pendiente Cotización",
    cotizado: "Cotizado",
    autorizado: "Autorizado",
    asignando_unidad: "Asignando Unidad",
    unidad_asignada: "Unidad Asignada",
    tripulacion_notificada: "Tripulación Notificada",
    en_salida: "En Salida",
    en_ruta_origen: "En Ruta al Origen",
    arribo_origen: "Arribo a Origen",
    valoracion_inicial: "Valoración Inicial",
    paciente_abordo: "Paciente Abordo",
    en_ruta_destino: "En Ruta a Destino",
    arribo_destino: "Arribo a Destino",
    entrega_paciente: "Entrega de Paciente",
    servicio_finalizado: "Servicio Finalizado",
    reporte_elaboracion: "Reporte en Elaboración",
    reporte_cerrado: "Reporte Cerrado",
    pendiente_facturacion: "Pendiente Facturación",
    facturado: "Facturado",
    pendiente_cobro: "Pendiente Cobro",
    cobrado: "Cobrado",
    cancelado: "Cancelado",
    rechazado: "Rechazado",
    reasignado: "Reasignado",
    incidencia: "Incidencia",
    siniestro: "Siniestro",
};

export const STATUS_COLORS = {
    solicitud_recibida: "fm-badge-warning",
    pendiente_cotizacion: "fm-badge-warning",
    cotizado: "fm-badge-neutral",
    autorizado: "fm-badge-info",
    asignando_unidad: "fm-badge-info",
    unidad_asignada: "fm-badge-info",
    tripulacion_notificada: "fm-badge-info",
    en_salida: "fm-badge-info",
    en_ruta_origen: "fm-badge-info",
    arribo_origen: "fm-badge-info",
    valoracion_inicial: "fm-badge-info",
    paciente_abordo: "fm-badge-info",
    en_ruta_destino: "fm-badge-info",
    arribo_destino: "fm-badge-info",
    entrega_paciente: "fm-badge-positive",
    servicio_finalizado: "fm-badge-positive",
    reporte_elaboracion: "fm-badge-warning",
    reporte_cerrado: "fm-badge-positive",
    pendiente_facturacion: "fm-badge-warning",
    facturado: "fm-badge-positive",
    pendiente_cobro: "fm-badge-warning",
    cobrado: "fm-badge-positive",
    cancelado: "fm-badge-critical",
    rechazado: "fm-badge-critical",
    incidencia: "fm-badge-critical",
    siniestro: "fm-badge-critical",
};

export const URGENCY_LABELS = {
    baja: "Baja",
    normal: "Normal",
    alta: "Alta",
    critica: "Crítica",
};

export const URGENCY_COLORS = {
    baja: "fm-badge-neutral",
    normal: "fm-badge-info",
    alta: "fm-badge-warning",
    critica: "fm-badge-critical",
};

export const ROLE_LABELS = {
    superadmin: "Superadministrador",
    direccion: "Dirección General",
    gerente: "Gerente Operativo",
    cabina: "Cabina / Despacho",
    coordinador: "Coordinador",
    paramedico: "Paramédico",
    operador: "Operador",
    medico: "Médico",
    enfermera: "Enfermería",
    finanzas: "Finanzas",
    comercial: "Comercial",
    cliente: "Cliente Corporativo",
    auditor: "Auditor",
};

export const UNIT_STATUS_LABELS = {
    disponible: "Disponible",
    ocupada: "Ocupada",
    mantenimiento: "En Mantenimiento",
    fuera_servicio: "Fuera de Servicio",
};

export const UNIT_STATUS_COLORS = {
    disponible: "fm-badge-positive",
    ocupada: "fm-badge-info",
    mantenimiento: "fm-badge-warning",
    fuera_servicio: "fm-badge-critical",
};

export const KANBAN_COLUMNS = [
    { key: "solicitudes", label: "Solicitudes", statuses: ["solicitud_recibida", "pendiente_cotizacion", "cotizado", "autorizado"] },
    { key: "asignacion", label: "Asignación", statuses: ["asignando_unidad", "unidad_asignada", "tripulacion_notificada"] },
    { key: "en_ruta", label: "En Ruta", statuses: ["en_salida", "en_ruta_origen", "arribo_origen", "valoracion_inicial", "paciente_abordo", "en_ruta_destino"] },
    { key: "en_destino", label: "En Destino", statuses: ["arribo_destino", "entrega_paciente"] },
    { key: "cierre", label: "Cierre & Facturación", statuses: ["servicio_finalizado", "reporte_elaboracion", "reporte_cerrado", "pendiente_facturacion"] },
];
